import styled from '@emotion/styled';
import {Grid, ListItemButton, Typography} from '@mui/material';
import {APP} from 'src/styles/variables';
import theme from 'src/styles/theme';

export const DocViewContainer = styled('div')<{
  isMultiPage: boolean;
  height?: string;
}>`
  display: contents;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  // width: 100%;
  width: max-content;
  overflow-y: auto;

  /* Customize scrollbar */
  // scrollbar-width: thin;
  // scrollbar-color: #bdbbbb #e3e1e1;
  // border-radius: 8px;
  // &::-webkit-scrollbar {
  //   width: 8px;
  //   border-radius: 8px;
  // }
  // &::-webkit-scrollbar-track {
  //   background: #f4f6f8;
  //   border-radius: 8px;
  // }
  // &::-webkit-scrollbar-thumb {
  //   background-color: ${theme.palette.primary.main};
  //   border-radius: 8px;
  //   border: 2px solid #f4f6f8;
  // }

  #pdf-zoom-out {
    display: none;
  }
  #pdf-zoom-in {
    display: none;
  }
  #pdf-zoom-reset {
    display: none;
  }
  #pdf-controls {
    background-color: ${APP.PALETTE.PRIMARY.CONTRAST_TEXT} !important;
    border: none;
    box-shadow: none;
    margin-top: 50px;
  }
  #header-bar {
    display: ${({isMultiPage}) => (isMultiPage ? '' : 'none')};
    margin-top: 50px;
  }
  #pdf-download {
    display: none;
  }
`;

export const PreviewerContainer = styled('div')`
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  will-change: max-width, max-height, width, height;
`;

export const TextContainer = styled(Grid)<{
  height?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({height}) => (height ? '75vh' : '65vh')};
  width: 100vw;
`;

export const TextFormatContainer = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
`;

export const AdditionalFeaturesContainer = styled('div')`
  width: 100%;
  color: #000;
  display: inline-block;
  padding-top: 10rem;
  padding-bottom: 10rem;
`;

export const AdditionalFeaturesDiv = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const ZoomButtonDiv = styled('div')`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ZoomButton = styled('button')`
  background-color: #ef476f;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 5px;
  height: 32px;
  padding-top: 4px;
`;

export const ZoomButtonsDiv = styled('div')<{
  top?: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SingleZoomButtonsDiv = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 55%;
  bottom: 50%;
`;

export const AdditionalFeaturesButtonDiv = styled('div')`
  display: flex;
`;

export const ViewDetailsButtonDiv = styled('div')`
  max-width: 6rem;
  width: 6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ViewDetailsButton = styled(ListItemButton)`
  min-height: 30px;
  margin-bottom: 0.5rem;
  padding: 0.2rem 0.5rem;
  max-width: 10rem;
  &:hover {
    text-decoration: underline;
    text-decoration-color: ${APP.PALETTE.PRIMARY.MAIN};
  }
`;

export const DownloadButtonDiv = styled('div')`
  max-width: 6rem;
  width: 6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DownloadButton = styled(ListItemButton)`
  min-height: 30px;
  margin-bottom: 0.5rem;
  padding: 0.2rem 0.5rem;
  max-width: 10rem;
  &:hover {
    text-decoration: underline;
    text-decoration-color: ${APP.PALETTE.PRIMARY.MAIN};
  }
`;

export const AdditionalFeaturesTypography = styled(Typography)`
  font-weight: 500;
  font-size: 15px !important;
  color: ${APP.PALETTE.PRIMARY.MAIN};
`;

export const TransformComponentDiv = styled('div')``;

export const PanToMoveDiv = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-left: 0.5rem;
  font-style: italic;
`;

export const MainContainerDiv = styled('div')`
position: relative;
  display: flex;
  flex-direction: column;
`;
